module.exports = __webpack_public_path__ + "img/tuto_internet_way_02_07.af161f45.png";